/** API route map: URLS.Controller.SentOfferLetter */
export const SentOfferLetter = {
      Name: 'SentOfferLetter/',
      GetOfferList: 'getOfferList',
      GetAll: 'getall',
      Add: 'add',
      PatchTaskStatus: 'patch-task-status',
};
